import React from 'react';

import { UserAvatar } from './Avatar';

import { Card, CardContent, CardHeader, List, ListItem, ListItemAvatar, ListItemText, makeStyles } from '@material-ui/core';
import { PersonOutlineOutlined } from '@material-ui/icons';

const useStyles = makeStyles((theme)=>({
    Card : {
        
        borderRadius : '0',
        backgroundColor : 'black',
        color: '#e5e7eb',

    },
    Text : {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '-0.011em',

    }
}))

const UserInfo = function UserInfo({ mode }) {

    const userName = localStorage.getItem('UserName')
    const classes = useStyles();

    return(
        <Card classes={{ root : classes.Card }} >
            <CardHeader 
                classes={{ title : classes.Text }}
                avatar={
                    <PersonOutlineOutlined />
                }
                title={mode}
            />
            <CardContent>
                <List>
                    <ListItem>
                        <ListItemAvatar>
                            <UserAvatar userName={userName} />
                        </ListItemAvatar>
                        <ListItemText primary={userName} />
                    </ListItem>
                </List>
            </CardContent>
        </Card>
    )

}

export default UserInfo;